import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { AXIS, GRID, TOOLTIP_STYLE } from './ChartCard.js';

interface Row {
  label: string;
  adr: number | null;
  revpar: number | null;
}

/** ADR & RevPAR (USD) over time, dual axis (chart #2). */
export function AdrRevparChart({ data }: { data: Row[] }) {
  return (
    <ResponsiveContainer width="100%" height={280}>
      <LineChart data={data} margin={{ top: 8, right: 16, bottom: 8, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={GRID} />
        <XAxis dataKey="label" tick={AXIS} />
        <YAxis yAxisId="adr" tick={AXIS} />
        <YAxis yAxisId="revpar" orientation="right" tick={AXIS} />
        <Tooltip contentStyle={TOOLTIP_STYLE} formatter={(v: number) => `$${v}`} />
        <Line
          yAxisId="adr"
          type="monotone"
          dataKey="adr"
          name="ADR $"
          stroke="#3b82f6"
          strokeWidth={2}
          dot={false}
          connectNulls
        />
        <Line
          yAxisId="revpar"
          type="monotone"
          dataKey="revpar"
          name="RevPAR $"
          stroke="#22c55e"
          strokeWidth={2}
          dot={false}
          connectNulls
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
